import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import LocaleSync from 'components/LocaleSync';
import ScrollToHash from 'components/ScrollToHash';
import Header from './templates/Header';
import Footer from './templates/Footer';

import About from './screens/About';
import Contact from './screens/Contact';
import Home from './screens/Home';
import CategoryDetail from './screens/CategoryDetail';

function App() {
  return (
    <Router>
      <ScrollToHash />
      <LocaleSync />
      <div className="app">
        <Header/>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/categories/:slug" element={<CategoryDetail />} />
          </Routes>
        </main>
        <Footer/>
      </div>
    </Router>
  );
}

export default App;
